import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpValidateAccesses, HttpValidateAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'

export const useValidateAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpValidateAccessesOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.VALIDATE_ACCESS],
        mutationFn: payload => httpValidateAccesses({payload}),
        // Validating accesses changes the validated/total counts shown while building an
        // activity report, so reset those counters on every validation regardless of caller.
        onSuccess: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            options?.onSuccess?.(...args)
        }
    })
}
